import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=2774207d&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774207d",
  null
  
)

export default component.exports